//https://app.zeplin.io/project/5d4d7c75ed27845211d13071/screen/5df10900a07a0cb288c0901e
import React, { FC } from 'react'
import styled from 'styled-components'
import { COLORS } from '../constants'

const primary = COLORS.brandblue.main
const secondary = '#fff'
const callToAction = COLORS.yellow.main
const disabled = COLORS.brandblue.bright_4
const disabledText = COLORS.brandblue.bright_2
const white = '#fff'
const typeDefaults: {
  [K in ButtonTypeKeys]: {
    [C in ColorMode]: { bg: string; fg: string }
  }
} = {
  primary: {
    light: { bg: primary, fg: white },
    dark: { bg: '#f00', fg: primary }
  },
  secondary: {
    light: { bg: secondary, fg: primary },
    dark: { bg: '#f00', fg: primary }
  },
  callToAction: {
    light: { bg: callToAction, fg: primary },
    dark: { bg: '#f00', fg: primary }
  },
  tenant: {
    light: { bg: callToAction, fg: white },
    dark: { bg: '#f00', fg: primary }
  }
}

const sizeDefaults: {
  [K in ButtonSizeKeys]: { minWidth: string; padding: string }
} = {
  small: { minWidth: '48px', padding: '8.5px 21px' },
  normal: { minWidth: '88px', padding: '16px 31px' },
  large: { minWidth: '128px', padding: '19px 51px' }
}

type StyledButtonProps = {
  s: ButtonSizeKeys
  t: ButtonTypeKeys
  m: ColorMode
  fullwidth: boolean
  disabled: boolean
  raised: boolean
  tenant: Tenant | undefined
}
const StyledButton = styled.button<StyledButtonProps>`
  font-family: IBM Plex Sans, sans-serif;
  border: 0;
  font-size: 16px;
  font-size: 16px;
  font-weight: ${props => (props.t === 'primary' ? '700' : '700')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: 0.4px;
  box-sizing: border-box;
  z-index: ${props => (props.t === 'primary' ? 100 : 1)};
  /* border: ${props =>
    props.t === 'primary'
      ? '1px solid var(--brandblue-bright-5)'
      : '1px solid var(--brandblue-bright-4)'}; */
  @media only screen and (min-width: 712px) {
    &:hover:not(:disabled) {
      /* background-color: var(--brandblue-bright-5); */
      opacity: .7;
      cursor: pointer;
    }
  }
  background-color: ${props =>
    props.disabled
      ? disabled
      : props.tenant
      ? COLORS.tenants[props.tenant]
      : typeDefaults[props.t][props.m].bg};
  color: ${props =>
    props.disabled
      ? disabledText
      : props.tenant
      ? white
      : typeDefaults[props.t][props.m].fg};
  min-width: ${props => sizeDefaults[props.s].minWidth};
  width: ${props => (props.fullwidth ? '100%' : 'auto')};
  padding: ${props => sizeDefaults[props.s].padding};
  margin-left: ${props => (props.fullwidth ? '0' : '30px')};
  margin-right: ${props => (props.fullwidth ? '0' : '30px')};
  box-shadow: ${props =>
    props.raised
      ? '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)'
      : 'unset'};
`

export const Button: FC<{
  children?: JSX.Element | string
  size?: ButtonSizeKeys
  type?: ButtonTypeKeys
  mode?: ColorMode
  fullWidth?: boolean
  disabled?: boolean
  raised?: boolean
  noMargin?: boolean
  [key: string]: any
}> = ({
  children,
  size = 'normal',
  type = 'primary',
  mode = 'light',
  fullWidth = false,
  disabled = false,
  raised = false,
  noMargin = false,
  forcedTenant,
  ...rest
}) => {
  return (
    <StyledButton
      s={size}
      t={type}
      m={mode}
      fullwidth={fullWidth}
      disabled={disabled}
      raised={raised}
      tenant={forcedTenant}
      {...rest}
    >
      {children && children}
    </StyledButton>
  )
}
